(function() {
  // 将topbar移动到header第一个，以达到topbar跟随header固定的效果
  const header = document.querySelector('header');
  const topbar = document.querySelector('.hdt-top-bar-section');
  header.insertBefore(topbar, header.childNodes[0]);
})();